import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import AppBar from "material-ui/AppBar";
import Typography from "material-ui/Typography";
import Button from "../../../Parts/Button";
import CompleteCircle from "../../../Icons/CompleteCircle";
import { SalesforceSettingDirectory, SalesforceTimelineStatusExportObjectType } from "../../../../constants/ComponentTypes";
import arrow from "../../../../assets/icons/arrow-left.svg";
import { reverseSalesforceExeExportMap } from "../../../../utils/utils";

const styles = () => ({
  root: {
    width: "100%",
    position: "fixed",
    bottom: 0,
    zIndex: 2,
    height: "76px",
    boxShadow: "0px -1px 3px #00000029",
    transition:
      "transform 0.3s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)",
  },

  appBar: {
    color: "#181819",
    background: "#FFFFFF",
    padding: "15px 25px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexDirection: "row",
  },

  flex: {
    flex: 1,
  },

  labels: {
    display: "flex",
    alignItems: "center",
  },

  labelContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: "20px",
  },

  label: {
    fontSize: "13px",
    fontWeight: "bold",
    color: "#B1B3B9",
    marginLeft: "6px",
  },
});

/**
 * ページ下部のプログレスバーのコントロール部分のコンポーネント
 * @see 「マッピング」と「確認」のステップでしか使わない
 */
class ProgressControl extends React.Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.step === this.props.salesforceSettingStep.PREVIEW
      && prevProps.isConfiguring !== this.props.isConfiguring
      && this.props.isConfiguring === false
      && this.props.errorMessage === ""
    ) {
      this.props.next();
    }
  }

  handleClickButton = () => {
    const { salesforceSettingStep, salesforceSettingDirectory } = this.props;
    if (this.props.step === salesforceSettingStep.MAPPING) {
      this.props.next();
    } else if (this.props.step === salesforceSettingStep.PREVIEW) {
      let map = reverseSalesforceExeExportMap(this.props.mapping);

      if (salesforceSettingDirectory.value === SalesforceSettingDirectory.TIMELINE_STATUS.value) {
        // 設定が完了したら、設定完了画面に遷移させるが、
        this.props.postSalesforceExportMappingsTimelineStatus({
          event: map[SalesforceTimelineStatusExportObjectType.EVENT.value],
        });
      }
    } else {
      return;
    }
  };

  isEmpty = (sobjectName, field) => {
    let map = reverseSalesforceExeExportMap(this.props.mapping);

    if (map.hasOwnProperty(sobjectName)) {
      return (
        Object.values(map[sobjectName]).find((f) => f === field) === undefined
      );
    } else {
      return true;
    }
  };

  disableBtn = () => {
    let res = false;
    this.props.requiredFields.forEach((field) => {
      res = res || this.isEmpty(field.sobject_name, field.field);
    });

    return res;
  };

  render() {
    const { classes, salesforceSettingStep } = this.props;

    return (
      <div
        className={classes.root}
        style={{ transform: "translateY(0%)", visibility: "visible" }}
      >
        <AppBar position="static" color="default" className={classes.appBar}>
          <Button
            text="戻る"
            size="large"
            type="line"
            icon={arrow}
            handleClickButton={this.props.prev}
          />
          <div className={classes.flex}></div>
          {this.props.step === salesforceSettingStep.MAPPING && (
            <div className={classes.labels}>
              {this.props.requiredFields.map((field, i) => {
                const selected = !this.isEmpty(field.sobject_name, field.field);
                return (
                  <div key={i} className={classes.labelContainer}>
                    <CompleteCircle
                      width={14}
                      height={14}
                      color={selected ? "#5593FF" : "#B1B3B9"}
                      style={{ display: "block" }}
                    />
                    <Typography
                      variant="body2"
                      className={classes.label}
                      style={{ color: selected ? "#5593FF" : "#B1B3B9" }}
                    >
                      {field.text}
                    </Typography>
                  </div>
                );
              })}
            </div>
          )}
          <Button
            text={
              this.props.step === salesforceSettingStep.MAPPING
                ? "次へ"
                : "設定を保存"
            }
            loading={this.props.isConfiguring}
            size="large"
            disabled={this.disableBtn()}
            handleClickButton={this.handleClickButton}
          />
        </AppBar>
      </div>
    );
  }
}

ProgressControl.propTypes = {
  classes: PropTypes.object.isRequired,
  step: PropTypes.number.isRequired,
  mapping: PropTypes.object.isRequired,
  salesforceSettingStep: PropTypes.object,
  requiredFields: PropTypes.array,
  next: PropTypes.func,
  prev: PropTypes.func,
  showPrevButton: PropTypes.bool,
  salesforceSettingDirectory: PropTypes.object,
  postSalesforceExportMappingsTimelineStatus: PropTypes.func,
  isConfiguring: PropTypes.bool,
  errorMessage: PropTypes.string,
};

export default withStyles(styles)(ProgressControl);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/common/ProgressControl.jsx